import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { Router, RouterModule } from '@angular/router';
import { StateService } from '../../services/state';
import detailsJson from '../../models/details.json';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
  selector: 'app-product-form',
  imports: [
    CommonModule,
    RouterModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatIconModule,
    MatCheckboxModule,
  ],
  templateUrl: './product-form.html',
  styleUrl: './product-form.scss',
})
export class ProductForm {
  private readonly router = inject(Router);
  private readonly stateService = inject(StateService);
  public stateData: any;
  public detailsData: any = detailsJson;
  public expandedDetail: string | null = null;
  productResultForm!: FormGroup;
  private readonly formBuilder = inject(FormBuilder);

  ngOnInit() {
    this.stateData = this.stateService.getState();

    if (!this.stateData || !this.stateData.idVersionDivina || !this.stateData.duration) {
      this.router.navigate(['/']);
    }

    this.productResultForm = this.formBuilder.group({
      checkCondiciones: [this.stateData?.checkCondiciones || false, Validators.requiredTrue],
      checkAvisoLegal: [this.stateData?.checkAvisoLegal || false, Validators.requiredTrue],
      checkCondicionesEspeciales: [
        this.stateData?.checkCondicionesEspeciales || false,
        Validators.requiredTrue,
      ],
      checkWhatsapp: [this.stateData?.checkWhatsapp || false],
    });
  }

  goToForm() {
    this.router.navigate(['/price-result']);
  }

  goToHome() {
    this.router.navigate(['/price-form/' + this.stateData?.vehicleCategory]);
  }

  contract() {
    this.stateService.setState(Object.assign(this.stateData, this.productResultForm.value));
    if (this.productResultForm.valid) {
      this.router.navigate(['/contract-form']);
    }
  }
}
